import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImgUrls } from '../../models/imgUrls.interface';

@Component({
  selector: 'app-thumbnail-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thumbnail-widget.component.html',
  styleUrls: ['./thumbnail-widget.component.scss'],
})
export class ThumbnailWidgetComponent implements OnInit {
  @Input() imgUrls: ImgUrls[] = [];
  @Output() imgClicked = new EventEmitter<ClickedImg>();

  constructor() {}

  ngOnInit(): void {}

  onClick(index: number, imgUrls: ImgUrls) {
    this.imgClicked.next({ index, imgUrls });
  }
}

export interface ClickedImg {
  index: number;
  imgUrls: ImgUrls;
}
